import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { BaseButton } from 'src/common/components/base-button';
import { openProductDisplay } from '../../business-logic/handle-plu-items';
import { IProductDisplayMenu } from 'src/common/interfaces/dtos/IProductDisplayMenu';
import { styles } from './styles';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';

interface PluMenuItemProps {
  item: IProductDisplayMenu;
  index: number;
  trainingModeActive: boolean;
  disabled: boolean;
  label?: string;
}

const PluMenuItem = ({
  item,
  index,
  trainingModeActive,
  disabled,
  label,
}: PluMenuItemProps): JSX.Element => {
  const classes = styles();
  const hasImage = item.ImageUrl || item.Image;
  const { showSidebar } = useResponsiveContext();

  return (
    <Box className={showSidebar ? classes.pluMenuTabContainer : ''}>
      <BaseButton
        data-testid={`plu-group-tab-${item.Name}`}
        buttonType='white'
        onClick={(): void => openProductDisplay(index, trainingModeActive)}
        className={!showSidebar ? classes.tabSmallForm : classes.tab}
        disabled={disabled}
      >
        <Grid container alignItems='center'>
          {hasImage && (
            <Grid item>
              <Box
                className={classes.pluMenuPicture}
                style={{
                  backgroundImage: item.Image
                    ? `url(data:image/png;base64,${item.Image})`
                    : `url(${item.ImageUrl})`,
                }}
              />
            </Grid>
          )}
          <Grid
            item
            className={!showSidebar ? classes.pluMenuTextSmallForm : classes.pluMenuText}
            data-testid='plu-group-tab'
          >
            {label ?? item.Name}
          </Grid>
        </Grid>
      </BaseButton>
    </Box>
  );
};

export default PluMenuItem;
